import React from 'react';
import { Button } from './ui/button';
import { ArrowRight, Clock } from 'lucide-react';
import { ctaData } from '../data/mock';

const CTA = ({ onContactClick }) => {
  return (
    <section className="py-20 bg-gradient-to-r from-[#1e3a5f] to-[#2d8b8b] text-white relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-64 h-64 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-5xl font-bold mb-6">
            {ctaData.title}
          </h2>
          <p className="text-xl text-gray-100 mb-8 leading-relaxed">
            {ctaData.subtitle}
          </p>

          {/* Urgency Banner */}
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-md border border-white/30 rounded-full px-6 py-3 mb-8">
            <Clock className="w-5 h-5 text-white" />
            <span className="text-white font-semibold">{ctaData.urgency}</span>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={onContactClick}
              size="lg"
              className="bg-white text-[#1e3a5f] hover:bg-gray-100 text-lg px-8 py-6 shadow-lg hover:shadow-xl transition-all duration-300"
            >
              {ctaData.ctaText}
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
            <Button
              onClick={onContactClick}
              size="lg"
              variant="outline"
              className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-[#1e3a5f] text-lg px-8 py-6 transition-all duration-300"
            >
              {ctaData.secondaryCta}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTA;
